module.exports = __webpack_public_path__ + "static/5-13c3f41c5cddd698704e1264f5f91d65.jpeg";